import React from 'react';
import { Document, Page, Text, View, StyleSheet,Image  } from '@react-pdf/renderer';
import QRCode from 'qrcode';

const styles = StyleSheet.create({
    page:        { padding: 40, fontSize: 11, fontFamily: 'Helvetica', color: '#1a1a1a' },
    headerBox:   { border: '1px solid #333', flexDirection: 'row', padding: '10 14', marginBottom: 14 },
    headerLeft:  { flex: 1 },
    headerRight: { width: 130, alignItems: 'flex-end', justifyContent: 'center' },
    examName:    { fontSize: 13, fontFamily: 'Helvetica-Bold', marginBottom: 6 },
    headerLine:  { fontSize: 11, marginBottom: 4 },
    headerRightLine: { fontSize: 11, marginBottom: 8 },
    instrTitle:  { fontFamily: 'Helvetica-Bold', fontSize: 11, marginBottom: 6 },
    instrItem:   { fontSize: 10, marginBottom: 3, flexDirection: 'row' },
    instrNo:     { width: 18 },
    instrText:   { flex: 1 },
    sectionBox:  {  alignItems: 'center', padding: '5 0', marginTop: 16, marginBottom: 6 },
    sectionTitle:{ fontFamily: 'Helvetica-Bold', fontSize: 16},
    sectionDesc: { fontFamily: 'Helvetica-Bold', fontSize: 12, marginBottom: 8 },
    questionRow: { flexDirection: 'row', marginBottom: 6, marginTop: 4 },
    qText:       { flex: 1, fontSize: 11, lineHeight: 1.4 },
    qMark:       { width: 40, fontSize: 11, fontFamily: 'Helvetica-Bold', textAlign: 'right' },
    optionsGrid: { flexDirection: 'row', flexWrap: 'wrap', marginTop: 4, marginBottom: 4 },
    optionItem:  { width: '50%', flexDirection: 'row', marginBottom: 3 },
    optKey:      { width: 18, fontSize: 10 },
    optText:     { fontSize: 10, flex: 1 },
    answerLine:  { borderBottom: '1px dotted #aaa', height: 14, marginTop: 4, marginBottom: 6 },
    diagramBox:   { alignItems: 'center', marginTop: 4, marginBottom: 6 },
    diagramImage: { width: 220, height: 160, objectFit: 'contain' },
    qrBox:   { marginTop: 24, alignItems: 'center' },
    qrImage: { width: 90, height: 90 },
    qrLabel: { fontSize: 9, marginTop: 4, color: '#555' },

    // Professional school header
    schoolHeader:  { alignItems: 'center', borderBottom: '2px solid #333', paddingBottom: 8, marginBottom: 8 },
    logoImg:       { width: 50, height: 50, marginBottom: 6 },
    logoBadge:     { width: 50, height: 50, borderRadius: 25, border: '2px solid #333', alignItems: 'center', justifyContent: 'center', marginBottom: 6 },
    logoBadgeText: { fontSize: 15, fontFamily: 'Helvetica-Bold', color: '#333' },
    schoolName:    { fontSize: 18, fontFamily: 'Helvetica-Bold', textAlign: 'center' },
    schoolSub:     { fontSize: 8, color: '#666', marginTop: 2 },
    examTitle:     { fontSize: 11, fontFamily: 'Helvetica-Bold', marginTop: 5, letterSpacing: 1 },
    metaRow:       { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12 },
    metaItem:      { fontSize: 11, marginBottom: 3 },
    metaBold:      { fontFamily: 'Helvetica-Bold' },
});

// title/setNo/duration/maxMarks optional hain � na diye jaayein to purana (H.S.S Public School,
// no Set line, 60 mins, ____) behavior hi chalta hai, taaki is component ka pehla caller
// (questionPaperGeneratorCtrl) bina kisi change ke chalta rahe.
function Header({ title, cls, subject, setNo, duration, maxMarks }) {
    return (
        <View style={styles.headerBox}>
            <View style={styles.headerLeft}>
                <Text style={styles.examName}>{title || "H.S.S Public School"}</Text>
                <Text style={styles.headerLine}>Class - <Text style={{ fontFamily: 'Helvetica-Bold' }}>{cls}</Text></Text>
                <Text style={styles.headerLine}>Subject - <Text style={{ fontFamily: 'Helvetica-Bold' }}>{subject}</Text></Text>
                {!!setNo &&
                    <Text style={styles.headerLine}>Set - <Text style={{ fontFamily: 'Helvetica-Bold' }}>{setNo}</Text></Text>
                }
            </View>
            <View style={styles.headerRight}>
                <Text style={styles.headerRightLine}>Duration : {duration || 60} mins</Text>
                <Text style={styles.headerRightLine}>Max. Marks : {maxMarks || '____'}</Text>
            </View>
        </View>
    );
}
function GeneralInstructions({ sections }) {
    return (
        <View style={{ marginBottom: 12 }}>
            <Text style={styles.instrTitle}>General Instructions</Text>
            <View style={styles.instrItem}>
                <Text style={styles.instrNo}>1.</Text>
                <Text style={styles.instrText}>There are total {sections.length} sections and all sections are mandatory.</Text>
            </View>
            {sections.map((sec, i) => (
                <View key={i} style={styles.instrItem}>
                    <Text style={styles.instrNo}>{i + 2}.</Text>
                    <Text style={styles.instrText}>
                        SECTION-{sec.section}: {sec.questionType} type questions. All are compulsory.
                    </Text>
                </View>
            ))}
         
        </View>
    );
}

function SectionBlock({ sec }) {
    const startQ = 1;
    const endQ   = sec.questions.length;

    return (
        <View>
            {/* Section heading box */}
            <View style={styles.sectionBox}>
                <Text style={styles.sectionTitle}>SECTION - {sec.section}</Text>
            </View>

            {/* Section description */}
            <Text style={styles.sectionDesc}>
              Questions from {startQ} to {endQ} are {sec.questionType} type questions and all  questions are compulsory in this section.
            </Text>

            {/* Questions */}
            {sec.questions.map((q, qi) => (
                <View key={qi} wrap={false}>
                    <View style={styles.questionRow}>
                        <Text style={styles.qText}>
                            <Text style={{}}>Ques. {`${q.quesNo}  `}</Text>
                            {q.ques}
                        </Text>
                    </View>

                    {/* Diagram image */}
                    {q.hasDiagram && q.diagramBase64 && (
                        <View style={styles.diagramBox}>
                            <Image style={styles.diagramImage} src={q.diagramBase64} />
                        </View>
                    )}

                    {/* MCQ options */}
                    {q.options && q.options.length > 0 && (
                        <View style={styles.optionsGrid}>
                            {q.options.map((op, i) => (
                                <View key={i} style={styles.optionItem}>
                                    <Text style={styles.optKey}>{String.fromCharCode(65 + i)})</Text>
                                    <Text style={styles.optText}>{op}</Text>
                                </View>
                            ))}
                        </View>
                    )}

                    {/* Fill blanks / Short / Long answer line */}
                    {(!q.options || q.options.length === 0) && (
                        <View style={styles.answerLine} />
                    )}
                </View>
            ))}
        </View>
    );
}
function QuestionPaperPdf({ result, cls, subject, title, setNo, duration, maxMarks }) {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Header title={title} cls={cls} subject={subject} setNo={setNo} duration={duration} maxMarks={maxMarks} />
                <GeneralInstructions sections={result.sections} />
                {result.sections.map((sec, i) => (
                    <SectionBlock key={i} sec={sec} />
                ))}
            </Page>
        </Document>
    );
}

export default QuestionPaperPdf;